import EditCommunicationProgram from './EditCommunicationProgram';

export default EditCommunicationProgram;